import InvoiceGenerator from './InvoiceGenerator';

function App() {
  return <InvoiceGenerator />;
}

export default App;
